import * as t from 'io-ts';

export const preAlertPortTo = t.union([
  t.literal('OSAKA'),
  t.literal('TOKYO'),
  t.literal('NAGOYA'),
  t.literal('HAKATA'),
  t.literal('KOBE'),
  t.literal(''),
]);

export const PORT_TO = preAlertPortTo.types.map((type) => type.value);
